import React from "react";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getDocDataSnap,
  setDocData,
  deleteObjectByUrl,
  deleteDocById,
} from "../Firebase/Firebase.utils";

import Button from "../components/Button";
import BuildingDetailsForm from "./BuildingDetailsForm";
import BuildingDetailsTable from "./BuildingDetailsTable";
import BuildingPhotos from "./BuildingPhotos";
import LeasingInformation from "../pages/Leasing/LeasingInformation";
import { v4 } from "uuid";
import { toast } from "react-toastify";
import NoPhoto from "../assets/No_Image_Available.jpg";
import { storage } from "../Firebase/Firebase.utils";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useSelector } from "react-redux";
import AssignedBuildingAgent from "./AssignedBuildingAgent";
import {
  FiEdit,
  FiSave,
  FiMapPin,
  FiTrash2,
  FiLayout,
  FiUpload,
  FiInfo,
  FiImage,
  FiDollarSign,
  FiUsers,
} from "react-icons/fi";

function BuildingDetails() {
  const id = useParams();
  const [doc, setDoc] = useState({});
  const [formData, setFormData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [activeMenu, setActiveMenu] = useState(1);
  const [floorPlanUpload, setFloorPlanUpload] = useState(null);
  const [url, setUrl] = useState("");
  const [progress, setProgress] = useState(0);

  const currentUser = useSelector((state) => state.userObject);

  useEffect(() => {
    const getDoc = async () => {
      const doc = await getDocDataSnap("masterlist", id.id, (doc) => {
        setDoc(doc);
      });
    };
    getDoc();
  }, []);

  useEffect(() => {
    setFormData(doc);
  }, [doc]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const tableFields = [
    {
      label: "Building Name",
      value: "buildingName",
      inputType: "text",
    },
    {
      label: "Address",
      value: "address",
      inputType: "text",
    },
    {
      label: "Google Maps Pin",
      value: "googleMapsPin",
      inputType: "text",
    },
    {
      label: "Business District",
      value: "businessDistrict",
      inputType: "text",
    },
    {
      label: "City",
      value: "city",
      inputType: "text",
    },
    {
      label: "Exclusive",
      value: "exclusive",
      inputType: "text",
    },

    {
      label: "Developer",
      value: "developer",
      inputType: "text",
    },
    {
      label: "Year Constructed",
      value: "yearConstructed",
      inputType: "text",
    },
    {
      label: "Certifications",
      value: "certifications",
      inputType: "text",
    },
    {
      label: "Total Floors",
      value: "totalFloors",
      inputType: "number",
    },
    {
      label: "Density",
      value: "density",
      inputType: "text",
    },

    {
      label: "Floor Efficiency",
      value: "floorEfficiency",
      inputType: "text",
    },

    {
      label: "Available Space in sqms",
      value: "totalAvailableSpace",
      inputType: "number",
    },
    {
      label: "Handover Condition",
      value: "handoverCondition",
      inputType: "text",
    },
    {
      label: "AC System",
      value: "acSystem",
      inputType: "text",
    },
    {
      label: "AC Charges",
      value: "acCharges",
      inputType: "text",
    },
    {
      label: "Quoted Rent",
      value: "quotedRent",
      inputType: "text",
    },
    {
      label: "CUSA per sqm per month",
      value: "cusa",
      inputType: "text",
    },
    {
      label: "Parking Rate per slot per month",
      value: "parkingRate",
      inputType: "text",
    },
    {
      label: "Building Grade",
      value: "buildingGrade",
      inputType: "text",
    },
    {
      label: "Gross Leasable Area",
      value: "grossLeasableArea",
      inputType: "text",
    },
    {
      label: "Floor Plate",
      value: "floorPlate",
      inputType: "text",
    },
    {
      label: "Net Usable Area",
      value: "netUseableArea",
      inputType: "text",
    },
    {
      label: "Backup Power",
      value: "backupPower",
      inputType: "text",
    },
    {
      label: "Elevators",
      value: "elevators",
      inputType: "text",
    },
    {
      label: "Telco Providers",
      value: "telcoProviders",
      inputType: "text",
    },
    {
      label: "Ceiling Height",
      value: "ceilingHeight",
      inputType: "text",
    },
    {
      label: "Parking Allocation",
      value: "parkingAllocation",
      inputType: "text",
    },
    {
      label: "24/7 Operations",
      value: "twentyFourSevenOperations",
      inputType: "text",
      placeholder: "Yes/No",
    },
    {
      label: "Subdivisions",
      value: "subdivisions",
      inputType: "text",
    },
    {
      label: "Retail Tenant in Office Floors",
      value: "retailTenantInOfficeFloors",
      inputType: "text",
      placeholder: "Yes/No",
    },
    {
      label: "BPO",
      value: "bpo",
      inputType: "text",
      placeholder: "Yes/No",
    },
    {
      label: "Online Gaming",
      value: "onlineGaming",
      inputType: "text",
      placeholder: "Yes/No",
    },
    {
      label: "Contact Person",
      value: "contactPerson",
      inputType: "text",
    },
    {
      label: "Contact Email",
      value: "contactEmail",
      inputType: "text",
    },
    {
      label: "Available Space",
      value: "availableSpace",
      inputType: "text",
    },
    {
      label: "Description",
      value: "description",
      inputType: "text",
    },
    {
      label: "Remarks",
      value: "remarks",
      inputType: "text",
    },
  ];

  const menuItems = [
    {
      label: "Details",
      id: 1,
      icon: <FiInfo size={18} />,
    },
    {
      label: "Photos",
      id: 2,
      icon: <FiImage size={18} />,
    },
    {
      label: "Leasing",
      id: 3,
      icon: <FiDollarSign size={18} />,
    },
    {
      label: "Team",
      id: 4,
      icon: <FiUsers size={18} />,
    },
  ];

  const handleEdit = (e) => {
    e.preventDefault();
    setIsEditing(!isEditing);
    if (isEditing) {
      const docObject = {
        ...formData,
        lastUpdatedBy: currentUser.email,
        lastUpdatedOn: new Date().toLocaleString(),
      };
      setDocData("masterlist", id.id, docObject);
    }
  };

  const handleFloorPlanUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const storageRef = ref(storage, `floorPlans/${id.id}/${v4()}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setUrl(downloadURL);
          setFormData({ ...formData, floorPlanUrl: downloadURL });
          setDocData("masterlist", id.id, { floorPlanUrl: downloadURL });
          toast.success("Floor Plan uploaded successfully");
          setProgress(0);
        });
      }
    );
    setFloorPlanUpload(null);
  };

  const handleDeleteFloorPlan = async (e) => {
    if (!window.confirm("Are you sure you want to delete this floor plan?")) {
      return;
    } else {
      e.preventDefault();
      setUrl("");
      setFormData({ ...formData, floorPlanUrl: "" });
      await setDocData("masterlist", id.id, { floorPlanUrl: "" });
      await deleteObjectByUrl(formData.floorPlanUrl).then(() => {
        toast.success("Floor Plan deleted successfully");
      });
    }
  };

  const navigate = useNavigate();

  const handleDeleteBuilding = async (e) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this building?")) {
      await deleteDocById("masterlist", id.id).then(() => {
        toast.success("Building deleted successfully");
        navigate("/leasing");
      });
    }
  };

  const handleToggleStatus = async (e) => {
    e.preventDefault();
    const newStatus =
      formData.webStatus === "published" ? "draft" : "published";
    setFormData({ ...formData, webStatus: newStatus });
    await setDocData("masterlist", id.id, { webStatus: newStatus });
  };

  return (
    <div className="flex flex-col gap-6 p-6 bg-white rounded-lg shadow-sm max-w-7xl mx-auto">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row gap-6 relative">
        {/* Left Column - Primary Image */}
        <div className="w-full md:w-1/3">
          <div className="rounded-lg overflow-hidden shadow-md border border-gray-100">
            <img
              src={formData.primaryPhotoUrl || NoPhoto}
              alt={formData.buildingName || "Building"}
              className="w-full h-64 object-cover"
            />
          </div>
        </div>

        {/* Right Column - Building Info */}
        <div className="w-full md:w-2/3 flex flex-col gap-4">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-2xl font-bold text-[#002368]">
                {formData.buildingName || "Building Details"}
              </h1>
              <p className="text-gray-600 mt-1">{formData.address}</p>

              {formData.googleMapsPin && (
                <a
                  href={formData.googleMapsPin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-[#ff5003] text-sm mt-2 hover:underline"
                >
                  <FiMapPin size={14} />
                  <span>View on Google Maps</span>
                </a>
              )}
            </div>

            {/* Status Badge */}
            <div>
              <button
                className={`px-4 py-2 rounded-full text-sm font-medium flex items-center gap-1 transition-all ${
                  formData?.webStatus === "published"
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={handleToggleStatus}
              >
                <span
                  className={`h-2 w-2 rounded-full ${
                    formData?.webStatus === "published"
                      ? "bg-green-500"
                      : "bg-gray-500"
                  }`}
                ></span>
                {formData?.webStatus === "published" ? "Published" : "Draft"}
              </button>
            </div>
          </div>

          {/* Key Property Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
            <div className="bg-gray-50 p-3 rounded-md">
              <p className="text-sm text-gray-500">Business District</p>
              <p className="font-medium">{formData.businessDistrict || "—"}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-md">
              <p className="text-sm text-gray-500">Developer</p>
              <p className="font-medium">{formData.developer || "—"}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-md">
              <p className="text-sm text-gray-500">Available Space</p>
              <p className="font-medium">
                {formData.totalAvailableSpace
                  ? `${formData.totalAvailableSpace} sqm`
                  : "—"}
              </p>
            </div>
            <div className="bg-gray-50 p-3 rounded-md">
              <p className="text-sm text-gray-500">Building Grade</p>
              <p className="font-medium">{formData.buildingGrade || "—"}</p>
            </div>
          </div>

          {/* Floor Plan Preview */}
          <div className="mt-2">
            <div className="flex items-center gap-2 mb-2">
              <FiLayout size={16} className="text-[#002368]" />
              <h3 className="text-lg font-medium text-[#002368]">Floor Plan</h3>
            </div>

            {formData.floorPlanUrl ? (
              <div className="relative">
                <div className="rounded-lg overflow-hidden border border-gray-200">
                  <img
                    className="w-full h-auto max-h-60 object-contain"
                    src={formData.floorPlanUrl}
                    alt="Floor Plan"
                  />
                </div>
                {isEditing && (
                  <button
                    className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-md hover:bg-red-50 transition-colors"
                    onClick={handleDeleteFloorPlan}
                    title="Delete floor plan"
                  >
                    <FiTrash2 size={16} className="text-red-500" />
                  </button>
                )}
              </div>
            ) : (
              <div className="bg-gray-50 p-4 rounded-lg border border-dashed border-gray-300 text-center">
                <p className="text-gray-500">No floor plan available</p>

                {isEditing && (
                  <div className="mt-2">
                    <label className="cursor-pointer inline-flex items-center gap-1 px-4 py-2 bg-[#002368] text-white rounded-md hover:bg-opacity-90 transition-all">
                      <FiUpload size={14} />
                      <span>Upload floor plan</span>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleFloorPlanUpload}
                        className="hidden"
                      />
                    </label>
                  </div>
                )}
              </div>
            )}

            {isEditing && formData.floorPlanUrl && (
              <div className="mt-4">
                <label className="cursor-pointer inline-flex items-center gap-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-all">
                  <FiUpload size={14} />
                  <span>Replace floor plan</span>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleFloorPlanUpload}
                    className="hidden"
                  />
                </label>
              </div>
            )}

            {progress !== 0 && (
              <div className="mt-2">
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div
                    className="bg-[#ff5003] h-2.5 rounded-full"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Admin Actions */}
      {currentUser.roles && currentUser.roles.includes("admin") && (
        <div className="flex justify-end">
          <button
            onClick={handleDeleteBuilding}
            className="text-red-500 hover:text-red-700 flex items-center gap-1 text-sm transition-colors"
          >
            <FiTrash2 size={14} />
            <span>Delete Building</span>
          </button>
        </div>
      )}

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <div className="flex flex-wrap gap-1">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`
                px-6 py-3 flex items-center gap-2 font-medium text-sm rounded-t-lg transition-all
                ${
                  activeMenu === item.id
                    ? "bg-[#002368] text-white border-b-2 border-[#ff5003]"
                    : "hover:bg-gray-50 text-gray-600"
                }
              `}
              onClick={() => setActiveMenu(item.id)}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="pb-4">
        {activeMenu === 1 && (
          <>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-[#002368]">
                Building Details
              </h2>
              <button
                onClick={handleEdit}
                className={`
                  flex items-center gap-2 px-5 py-2 rounded-md font-medium transition-all
                  ${
                    isEditing
                      ? "bg-[#ff5003] text-white hover:bg-opacity-90"
                      : "bg-[#002368] text-white hover:bg-opacity-90"
                  }
                `}
              >
                {isEditing ? (
                  <>
                    <FiSave size={16} />
                    <span>Save Changes</span>
                  </>
                ) : (
                  <>
                    <FiEdit size={16} />
                    <span>Edit Details</span>
                  </>
                )}
              </button>
            </div>

            {!isEditing ? (
              <BuildingDetailsTable
                formData={formData}
                tableFields={tableFields}
              />
            ) : (
              <BuildingDetailsForm
                formData={formData}
                handleChange={handleChange}
                isEditing={isEditing}
                formFields={tableFields}
              />
            )}
          </>
        )}

        {activeMenu === 2 && (
          <div className="flex flex-col">
            <h2 className="text-xl font-semibold text-[#002368] mb-6">
              Building Photos
            </h2>
            <BuildingPhotos buildingId={id.id} buildingDoc={doc} />
          </div>
        )}

        {activeMenu === 3 && (
          <div>
            <h2 className="text-xl font-semibold text-[#002368] mb-6">
              Leasing Information
            </h2>
            <LeasingInformation />
          </div>
        )}

        {activeMenu === 4 && (
          <div>
            <h2 className="text-xl font-semibold text-[#002368] mb-6">
              Team Members
            </h2>
            <AssignedBuildingAgent />
          </div>
        )}
      </div>
    </div>
  );
}

export default BuildingDetails;
